module.exports = __webpack_public_path__ + "static/media/Icon-Blue.6690eb72.jpg";